// import { defineMessages } from 'react-intl'
//
// defineMessages(
//
// )

export const STONES_FAMILIES = {
    Granite: 'GRANITO',
    Marble: 'MARMOL',
    Travertine: 'TRAVERTINO',
    Quartzite: 'CUARCITA',
    Onyx: 'ONIX',
    Limestone: 'CALIZA',
    Sandstone: 'ARENISCA'
}

export const REPO_STONES_FAMILIES = {
    GRANITO: 'granite',
    MARMOL: 'marble',
    TRAVERTINO: 'travertine',
    CUARCITA: 'quartzite',
    ONIX: 'onyx',
    CALIZA: 'limestone',
    ARENISCA: 'sandstone',
}